
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import CountDown from '@/components/countdown/index.vue';
import {
  aliPayPc, orderDetail, pageVisit, getDataCard,
  getDataBanner,
  getDataReCommend,
  getDataProType
} from '@/services/http';
import { secondToTime, readCookie, writeCookie } from '@/tools/tools';

@Component({
  name: 'Payment',
  components: {
    Header,
    Footer,
    CountDown,
  }
})
export default class extends Vue {
  // 支付类型，1支付宝支付,2微信支付,
  radio: number = readCookie('paytype') ? readCookie('paytype') : 1

  totalPrice: string = ''

  paytime: number = 0 // 订单支付倒计时时间

  surplus: number = 0

  created() {
    this.getPayTime();
  }

  destroyed() {

  }

  beforeRouteLeave(to: any, from: any, next: Function) {
    if (to.name === 'orderConfirm') {
      next(false);
      this.$msgbox({
        title: '确认要取消支付订单?',
        message: `您的订单在${secondToTime(this.surplus)}内未支付将被取消，请尽快完成支付。`,
        showCancelButton: true,
        confirmButtonText: '确认离开',
        cancelButtonText: '继续支付',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            this.$router.push({ path: '/order-list?id=0' });
            done();
          } else {
            this.gopay();
            done();
          }
        }
      });
    } else {
      next(true);
    }
  }

  selectPay(radio:number) {
    this.radio = radio;
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 10,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }

  private async gopay() {
    const anchor = readCookie('anchor');
    const { from } = this.$route.query;
    let url;
    if (from === 'card') {
      url = getDataCard;
    } else if (from === 'classify') {
      url = getDataProType;
    } else if (from === 'carousel') {
      url = getDataBanner;
    } else {
      url = getDataReCommend;
    }
    if (this.radio === 1) {
      const res: any = await aliPayPc({
        orderNo: this.$route.query.id,
        equip: '',
        version: ''
      });
      if (res.data.code === 100) {
        if (from) {
          await url({
            src: anchor ? (anchor.src ? anchor.src : 2) : 4,
            equip: anchor ? anchor.equip : 4,
            version: anchor ? anchor.version : '',
            model: anchor ? anchor.model : '',
            equipVersion: anchor ? anchor.equipVersion : '',
            equipMeid: anchor ? anchor.equipMeid : '',
            companyId: 1,
            // eslint-disable-next-line no-nested-ternary
            eventNo: from === 'card' ? '2.2.1.1.1.0.1' : from === 'classify' ? '2.3.1.1.1.1.1' : from === 'carousel' ? '2.4.1.1.1.0.1' : from === 'hotlist' ? '2.5.1.1.1.0.1' : ''
          });
        }
        const div = document.createElement('div');
        document.body.appendChild(div);
        div.innerHTML = res.data.data.form;
        document.forms[0].submit();
        writeCookie('paytype', this.radio);
      } else {
        this.$message.error(res.data.message);
      }
    } else if (this.radio === 2) {
      if (from) {
        await url({
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          // eslint-disable-next-line no-nested-ternary
          eventNo: from === 'card' ? '2.2.1.1.1.0.2' : from === 'classify' ? '2.3.1.1.1.1.2' : from === 'carousel' ? '2.4.1.1.1.0.2' : from === 'hotlist' ? '2.5.1.1.1.0.2' : ''
        });
      }
      writeCookie('paytype', this.radio);
      this.$router.push(`/paymentwx?id=${this.$route.query.id}`);
    } else if (this.radio === 3) {
      // 对公打款先进入提交成功页，再从“去打款”打开进度弹窗
      writeCookie('paytype', this.radio);
      this.$router.push(`/transfer-payment?id=${this.$route.query.id}`);
    }
  }

  //  获取支付倒计时时间
  private async getPayTime() {
    const anchor = readCookie('anchor');
    const res: any = await orderDetail({
      orderNo: this.$route.query.id,
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : ''
    });
    if (res.data.code === 100) {
      this.paytime = Date.now() + Number(res.data.data.surplus) * 1000;
      this.surplus = +res.data.data.surplus;
      this.totalPrice = res.data.data.totalAmount;
    }
  }
}
